import * as React from "react"
import { Spacer, Card, CardHeader, CardSection, Text } from "gatsby-interface"
import { FormattedMessage } from "@modules/locales"
import { importSiteNew as newImportSiteText } from "@modules/locales/default.js"
import CmsIntegration from "./CmsIntegration"

function InactiveCmsIntegration() {
  return (
    <div>
      <Text
        css={theme => ({
          color: theme.colors.grey[50],
        })}
      >
        <FormattedMessage<never, "span">
          message={newImportSiteText.headers.cmsIntegrationsStep}
          tags={{
            span: function(content) {
              return (
                <span css={{ fontFamily: `monospace`, whiteSpace: `pre` }}>
                  {content}
                </span>
              )
            },
          }}
        />
      </Text>
      <Spacer size={8} />
      <Text
        css={theme => ({
          color: theme.colors.grey[50],
        })}
      >
        <FormattedMessage<never, "link">
          message={
            "You can connect to <link>our officially supported integrations</link> at any time through your site’s settings."
          }
          tags={{
            link: function(content) {
              return (
                <a
                  href={`https://support.gatsbyjs.com/hc/en-us/sections/360011112314-Connecting-to-a-Content-Management-System`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {content}
                </a>
              )
            },
          }}
        />
      </Text>
    </div>
  )
}

export default function CmsIntegrationCard({
  siteId,
  onNext,
}: {
  siteId: string | null
  onNext: () => void
}) {
  const isActive = siteId !== null

  return (
    <Card
      css={theme => ({
        background: !isActive && theme.colors.grey[5],
      })}
    >
      <CardHeader
        title="Connect Integrations"
        // not ideal, but how we need to override font family to be Inter
        css={theme => ({
          h3: {
            fontFamily: theme.fonts.heading,
          },
          "& > *": { color: !isActive && theme.colors.grey[50] },
        })}
      />
      <CardSection>
        {siteId ? (
          <CmsIntegration siteId={siteId} onNext={onNext} />
        ) : (
          <InactiveCmsIntegration />
        )}
      </CardSection>
    </Card>
  )
}
